import React from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../theme/ThemeContext";
import { makeStyles } from "@material-ui/core";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import { Autocomplete, Grid } from "@mui/material";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CommonUtil from "../../Util/CommonUtils";
import { useState } from "react";
import Toast from "../../components/ToastContainer/CustomToast";

const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .MuiDialog-paper": {
      // minWidth: '110vh',
      maxWidth: "600px",
      // marginLeft: "250px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

function DayLightFilter(props) {
  const { t } = useTranslation();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [open, setOpen] = React.useState(props.open);
  const classes = useStyles({ darkMode });
  const { handleClose } = props;
  const [timeZone, setTimeZone] = useState(null);
  const [state, setState] = useState({
    name: "",
    timeZone: "",
  });

  const timeZoneOptions = Object.entries({
    "(UTC-12:00)International Date Change Line West": "-12:00",
    "(UTC-11:00)Coordinated Universal Time-11": "-11:00",
    "(UTC-10:00)Hawaii": "-10:00",
    "(UTC-09:00)Alaska": "-09:00",
    "(UTC-08:00)Pacific time (American and Canada)  Baja California": "-08:00",
    "(UTC-07:00)La Paz, Massa Rand, The mountain time (American and Canada), Arizona":
      "-07:00",
    "(UTC-06:00)Saskatchewan, Central time, Central America": "-06:00",
    "(UTC-05:00)Bogota, Lima, Quito, Leo Branco, Eastern time, Indiana(East)":
      "-05:00",
    "(UTC-04:30)Caracas": "-04:30",
    "(UTC-04:00)Atlantic time, Cuiaba, Georgetown, La Paz, Santiago": "-04:00",
    "(UTC-03:30)Newfoundland": "-03:30",
    "(UTC-03:00)Brasilia, Buenos Aires, Greenland, Cayenne": "-03:00",
    "(UTC-02:00)The International Date Line West-02": "-02:00",
    "(UTC-01:00)Cape Verde Islands, Azores": "-01:00",
    "(UTC 00:00)Dublin, Edinburgh, Lisbon, London, The International Date Line West":
      "00:00",
    "(UTC+01:00)Amsterdam, Brussels, Sarajevo": "+01:00",
    "(UTC+02:00)Beirut, Damascus, Eastern Europe, Cairo,Athens, Jerusalem":
      "+02:00",
    "(UTC+03:00)Baghdad, Kuwait, Moscow, St Petersburg,Nairobi": "+03:00",
    "(UTC+03:30)Teheran or Tehran": "+03:30",
    "(UTC+04:00)Abu Zabi, Yerevan, Baku, Port Louis, Samarra": "+04:00",
    "(UTC+04:30)Kabul": "+04:30",
    "(UTC+05:00)Ashkhabad, Islamabad, Karachi": "+05:00",
    "(UTC+05:30)Chennai, Calcutta Mumbai, New Delhi": "+05:30",
    "(UTC+05:45)Katmandu": "+05:45",
    "(UTC+06:00)Astana, Dhaka, Novosibirsk": "+06:00",
    "(UTC+06:30)Yangon": "+06:30",
    "(UTC+07:00)Bangkok, Hanoi, Jakarta": "+07:00",
    "(UTC+08:00)Beijing, Chinese Taipei, Irkutsk, Ulan Bator": "+08:00",
    "(UTC+09:00)Osaka, Tokyo, Seoul, Yakutsk": "+09:00",
    "(UTC+09:30)Adelaide, Darwin": "+09:30",
    "(UTC+10:00)Brisbane, Vladivostok, Guam, Canberra": "+10:00",
    "(UTC+11:00)Jo Kul Dah, Solomon Islands, New Caledonia": "+11:00",
    "(UTC+12:00)Anadyr, Oakland, Wellington, Fiji": "+12:00",
    "(UTC+13:00)Nukualofa, The Samoa Islands": "+13:00",
    "(UTC+14:00)Christmas Island": "+14:00",
  }).map(([label, value]) => ({ label, value }));

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  const handleTimeZoneChange = (event, newValue) => {
    if (!CommonUtil.isEmpty(newValue)) {
      setTimeZone(newValue);
      setState({
        ...state,
        timeZone: newValue.value,
        address: {
          ...state.address,
          timeZone: newValue.value,
        },
      });
    } else {
      setTimeZone(null);
      setState({
        ...state,
        timeZone: "",
      });
    }
  };

  const handleSubmit = () => {
    if (
      CommonUtil.isEmptyString(state.name) &&
      CommonUtil.isEmptyString(state.timeZone)
    ) {
      Toast(t("FILTERISEMPTY"), "error");
      return;
    }
    props.handleFilter(state);
  };

  return (
    <>
      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("COMMON006")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid container rowSpacing={2}>
          <Grid item sm={12}>
            <CustomTextfield
              label={t("COMMON044")}
              //   error={error.name}
              name="name"
              value={state.name}
              handleChange={(e) => handleChange(e)}
              //   helperText={error.name}
            />
          </Grid>
          <Grid item sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              required={true}
              style={{ width: "100%" }}
              noOptionsText={"No Options found"}
              name="timeZone"
              //   value={timeZone}
              options={
                CommonUtil.isEmptyArray(timeZoneOptions) ? [] : timeZoneOptions
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              getOptionLabel={(option) => (option.label ? option.label : "")}
              onChange={handleTimeZoneChange}
              renderInput={(params) => (
                <CustomTextfield
                  //   required={true}
                  {...params}
                  name="timeZone"
                  //   value={state.address.timeZone}
                  //   error={error.timeZone}
                  variant="outlined"
                  fullWidth
                  label={t("ADD010")}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}

export default DayLightFilter;
